<template>
	<div class="bfsp-box">
		<!-- 左上角关闭按钮 -->
		<div class="bfsp-close" @click="handleBack">
			<svg viewBox="0 0 24 24" width="22" height="22">
				<path d="M6 6l12 12M18 6L6 18" stroke="#FFFFFF" stroke-width="2.4" stroke-linecap="round"/>
			</svg>
		</div>
		<!-- 短影音播放组件：
			 首页短视频 tab 进来 → query 有 videoCateId，传 isHost=''(全部) 或 1(热门)，不传 userId，走平台公共流；
			 个人页(wode / yonghuzhuye)进来 → query 有 userId，走 viewUserVideoList 查该用户视频；
			 两种入口都传 videoId 用于定位到初始播放视频。
		-->
		<duanshippin
			:userId="userId"
			:videoId="videoId"
			:isHost="isHost"
		></duanshippin>
	</div>
</template>

<script>
import duanshippin from "../../../components/duanshippin/duanshippin.vue"
export default {
  components: {
	duanshippin
  },
  data() {
    return {
	  userId: this.$route.query.userId || '',
	  videoId: this.$route.query.videoId || '',
	  // 首页短视频 tab 进来：query 带 isHost（0=全部, 1=热门）；
	  // 个人页(wode / yonghuzhuye)进来：query 只有 userId，isHost 为 undefined，duanshippin 忽略
	  isHost: this.$route.query.isHost !== undefined ? Number(this.$route.query.isHost) : undefined
    };
  },
  mounted() {

  },
  methods: {
	// 返回上一页；历史栈为空时（外部链接直达 / 新标签打开）兜底回首页
	handleBack() {
		if (window.history.length > 1) {
			this.$router.go(-1);
		} else {
			this.$router.push('/shouye');
		}
	},

  }
};
</script>
<style scoped lang="scss">
	.bfsp-box{
		position: fixed;
		top: 60px;
		left: 158px;
		right: 0;
		bottom: 66px;
		background: #161823;
		overflow: hidden;
		z-index: 5;
	}
	.bfsp-close{
		position: absolute;
		top: 24px;
		left: 24px;
		width: 56px;
		height: 56px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 100;
	}
</style>



// WEBPACK FOOTER //
// bofangshipin.vue?6b17b187